import { render, staticRenderFns } from "./sign.vue?vue&type=template&id=18fd31c1&scoped=true&"
import script from "./sign.vue?vue&type=script&lang=js&"
export * from "./sign.vue?vue&type=script&lang=js&"
import style0 from "./sign.vue?vue&type=style&index=0&lang=css&"
import style1 from "./sign.vue?vue&type=style&index=1&id=18fd31c1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fd31c1",
  null
  
)

export default component.exports